import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppSelector } from 'src/hooks/store';
import { selectedWarehouseIdSelector } from 'src/state/selectors/delivery';
import { isWarehouseFlagEnabled } from 'src/utils/warehouseFlag';

// deliveryServiceWarehouseLayoutBuilderPage is a warehouse-array flag: the
// variation value is the list of warehouse ids the Layout Builder is enabled
// for ('*' = all). Returns undefined while LaunchDarkly is still loading, so
// callers that redirect can tell "off" apart from "not known yet".
export const useWarehouseLayoutBuilderEnabled = (): boolean | undefined => {
  const { deliveryServiceWarehouseLayoutBuilderPage } = useFlags();
  const selectedWarehouseId = useAppSelector(selectedWarehouseIdSelector);

  if (deliveryServiceWarehouseLayoutBuilderPage === undefined) return undefined;
  return isWarehouseFlagEnabled(
    deliveryServiceWarehouseLayoutBuilderPage,
    selectedWarehouseId,
  );
};
